import React from "react";
import CardsSlider from "../../../Components/CardsSilder";
import Heading from "../../../Components/Heading";
import routesIcon from "../../../Assets/routesIcon.png";
import styles from "./style.module.css";
import { routesData } from "../../../logics/Data";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Routes = () => {

  const { t } = useTranslation();
  
  return (
    <div className="container py-5 ">
      <section className={styles.eventHeader}>
        <Heading label={t("routes")} width="60px" img={routesIcon} style={{ fontWeight: "bold" }} bottom="5px" />
        <Link to={"/routes"}>
          <button>See All</button>
        </Link>
      </section>
      <section>
        <CardsSlider data={routesData} name="routes" />
      </section>
    </div>
  );
};

export default Routes;
